export default "__VITE_ASSET__9ff48562__"